const clampValue = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const DPDG_BALL_SIZE_MIN = 30;
export const DPDG_BALL_SIZE_MAX = 120;

export const DPDG_SIZE_SLIDER_MIN = 1;
export const DPDG_SIZE_SLIDER_MAX = 30;

export const clampBallSize = (size: number | null | undefined): number => {
  if (typeof size !== 'number' || Number.isNaN(size)) {
    return DPDG_BALL_SIZE_MIN;
  }

  return clampValue(size, DPDG_BALL_SIZE_MIN, DPDG_BALL_SIZE_MAX);
};

export const mapSliderStepToBallSize = (step: number): number => {
  const sliderRange = DPDG_SIZE_SLIDER_MAX - DPDG_SIZE_SLIDER_MIN;
  if (sliderRange <= 0) {
    return DPDG_BALL_SIZE_MIN;
  }

  const clampedStep = clampValue(step, DPDG_SIZE_SLIDER_MIN, DPDG_SIZE_SLIDER_MAX);
  const ratio = (clampedStep - DPDG_SIZE_SLIDER_MIN) / sliderRange;
  const size = DPDG_BALL_SIZE_MIN + ratio * (DPDG_BALL_SIZE_MAX - DPDG_BALL_SIZE_MIN);

  return Math.round(size);
};

export const mapBallSizeToSliderStep = (size: number): number => {
  const sizeRange = DPDG_BALL_SIZE_MAX - DPDG_BALL_SIZE_MIN;
  if (sizeRange <= 0) {
    return DPDG_SIZE_SLIDER_MIN;
  }

  const clampedSize = clampBallSize(size);
  const ratio = (clampedSize - DPDG_BALL_SIZE_MIN) / sizeRange;
  const sliderValue = DPDG_SIZE_SLIDER_MIN + ratio * (DPDG_SIZE_SLIDER_MAX - DPDG_SIZE_SLIDER_MIN);

  return Math.round(clampValue(sliderValue, DPDG_SIZE_SLIDER_MIN, DPDG_SIZE_SLIDER_MAX));
};

